var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2388 0.839393H9.28936V0.583722C9.28936 0.261508 9.02785 0 8.70563 0H5.11574C4.79353 0 4.53202 0.261508 4.53202 0.583722V0.839393H0.583722C0.261508 0.839393 0 1.1009 0 1.42312C0 1.74533 0.261508 2.00684 0.583722 2.00684H1.07405V12.2488C1.07405 13.2143 1.85974 14 2.82521 14H10.9973C11.9628 14 12.7485 13.2143 12.7485 12.2488V2.00684H13.2388C13.561 2.00684 13.8225 1.74533 13.8225 1.42312C13.8225 1.1009 13.5622 0.839393 13.2388 0.839393ZM11.5811 12.2488C11.5811 12.571 11.3195 12.8326 10.9973 12.8326H2.82521C2.503 12.8326 2.24149 12.571 2.24149 12.2488V2.00684H11.5811V12.2488Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3795 10.8771C5.70171 10.8771 5.96322 10.6156 5.96322 10.2934V4.2437C5.96322 3.92148 5.70171 3.65997 5.3795 3.65997C5.05728 3.65997 4.79578 3.92148 4.79578 4.2437V10.2934C4.79578 10.6168 5.05612 10.8771 5.3795 10.8771Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44407 10.8771C8.76629 10.8771 9.0278 10.6156 9.0278 10.2934V4.2437C9.0278 3.92148 8.76629 3.65997 8.44407 3.65997C8.12186 3.65997 7.86035 3.92148 7.86035 4.2437V10.2934C7.86035 10.6168 8.12186 10.8771 8.44407 10.8771Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.7c7deb1c9111c7e62344d8cdf0c6f7bc.svg";
export { ForwardRef as ReactComponent };